module.exports = __webpack_public_path__ + "img/ec-w.d7c18491.svg";